import { useFreeTrial } from '@/shared/hooks/useFreeTrial';

function useCheckSubscriptionStatus() {
  const { freeTrialOver, hasSubscription } = useFreeTrial();

  return freeTrialOver && !hasSubscription;
}

export default useCheckSubscriptionStatus;
